import { render } from "./resultTableWorkflow.vue?vue&type=template&id=b470ed8e&scoped=true"
import script from "./resultTableWorkflow.vue?vue&type=script&lang=js"
export * from "./resultTableWorkflow.vue?vue&type=script&lang=js"

import "./resultTableWorkflow.vue?vue&type=style&index=0&id=b470ed8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b470ed8e"]])

export default __exports__